<div class="text-center mt-5">
<button class="btn btn-primary mb-5"  (click)="testImage()">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
    Test Image</button>
<div *ngIf="imageSource" class="p-2">
    <span [innerHTML]="imageSource"></span>
</div>
</div>

